import { motion } from "framer-motion";

const Faith = () => {
  return (
    <section
      id="proposito"
      className="relative overflow-hidden bg-[#FDFBF7] py-20 md:py-28"
      data-testid="faith-section"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-6 md:px-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="absolute -inset-3 rounded-[2.5rem] border border-[#D4AF37]/30" />
          <img
            src="https://customer-assets-eiarnc6j.emergentagent.net/job_metodo-mariana/artifacts/38zdzdff_IMG_0553.JPG"
            alt="Dra. Mariana Alves sorrindo"
            className="relative h-[500px] w-full rounded-[2rem] object-cover"
            data-testid="faith-image"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Fé &amp; Propósito
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line"
            data-testid="faith-title"
          >
            Cuidar da saúde é <em className="italic">honrar a vida.</em>
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-[#4E342E]/85 md:text-lg">
            <p>
              Acredito que cuidar da saúde também é uma forma de honrar o corpo
              que recebemos. Por isso, meu atendimento busca enxergar cada
              paciente de forma individual, respeitando sua história, seus
              desafios e seus objetivos.
            </p>
            <p className="font-serif text-xl italic text-[#8B6F1F]">
              Minha missão é servir através da medicina e ajudar mulheres a
              viverem com mais saúde, energia e propósito.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Faith;
